export const customersApi = (client) => ({
    list: () => client.get('/api/v1/customers').then((r) => r.data),
    get: (id) => client.get(`/api/v1/customers/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/customers', body).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/customers/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/customers/${id}`).then((r) => r.data),
    /** Which customers a given user can access. */
    listForUser: (userId) => client.get(`/api/v1/customers/users/${userId}`).then((r) => r.data),
    /** Replace a user's customer set wholesale. `unassigned` lists any
     *  open/in_progress WOs/tasks freed up because the new set no longer
     *  covers them — empty when the change only grew access. */
    setForUser: (userId, customer_ids) => client.put(`/api/v1/customers/users/${userId}`, { customer_ids }).then((r) => r.data),
});
//# sourceMappingURL=customers.js.map